const topHatData = (state) => {
  return state.topHatData;
};

export default { topHatData };
